import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { BlobServiceClient } from "@azure/storage-blob";
import {
  CheckCircleGreen,
  FileDescription,
  RollingLoaderGif,
  UploadFileIcon,
  deleteIcon,
} from "../../../assets/images";

import "./upload.scss";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";

type AppProps = {
  toggleModal?: any;
  modal?: boolean;
  client_code?: number | string;
  token?: string | null;
  fetchNewData?: any;
  handleUploadFile?: (data: UploadFileTypesPayload) => void;
  currentFolder?: any;
  isDraggableModal?: boolean;
  acceptedFiles?: string;
  supportedFiles?: string;
  maxFileSize?: number;
  uploadSuccess?: number | null;
  uploadFetching?: boolean;
  uploadSuccessArray: [] | any;
  dispatchResetUploadFileData?: () => void;
  callbackAfterUploadAllFile?: () => void;
};

const FileManagerUploadModal = ({
  toggleModal,
  modal,
  client_code,
  acceptedFiles,
  supportedFiles,
  maxFileSize,
  handleUploadFile,
  isDraggableModal,
  uploadFetching,
  uploadSuccessArray,
  dispatchResetUploadFileData,
}: AppProps) => {
  const [fileNames, setFileNames] = useState([]);

  const [fileData, setFileData] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [filesSize, setFileSize] = useState("");
  const [fetchingStart, setFetchingStart] = useState(false);
  const [maxFile, setMaxFile] = useState("");
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName = `clientcontainer${client_code}`;
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const maxSize = 50000000; //50mb file size

  useEffect(() => {
    if (!modal) {
      setFileSize("");
      setFetchingStart(false);
      setMaxFile("");
      setFileNames([]);
      setFileData("");
      dispatchResetUploadFileData && dispatchResetUploadFileData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  useEffect(() => {
    if (fileData?.length <= 20) {
      setMaxFile("");
    }
    if (fileData.length > 20) {
      setMaxFile("You Can upload only 20 File");
    } else {
      setMaxFile("");
    }

    if (fileData.length) {
      const sizes =
        fileData?.length > 0 && fileData.map((file: any) => file.size);
      const updatedTotalSize =
        sizes?.length > 0 &&
        sizes.reduce((sum: number, size: number) => sum + size, 0);
      setFileSize(updatedTotalSize);
    }
  }, [fileData]);

  const handleDrop = (acceptedFiles: any[string]) => {
    const sizes =
      fileData?.length > 0 && fileData.map((file: any) => file.size);
    const updatedTotalSize =
      sizes?.length > 0 &&
      sizes.reduce((sum: number, size: number) => sum + size, 0);
    if (updatedTotalSize) {
      let finalSize = acceptedFiles?.map((el: any) => {
        return updatedTotalSize + el.size;
      });
      setFileSize(finalSize[0]);
    }
    if (fileData?.length > 0) {
      let count = 1;

      let nameAcceptedFiles = acceptedFiles.map((el: any, index: number) => {
        if (fileData.find((file: any) => file.name == el.name)) {
          let splitName = el.name?.split(".");
          count++;

          let joinName =
            splitName[splitName?.length - 2] +
            "_copy" +
            (fileData?.length + 1) +
            "." +
            splitName[splitName?.length - 1];
          return new File([el], `${joinName}`, { type: el.type });
        } else {
          return el;
        }
      });

      setFileData([...nameAcceptedFiles, ...fileData]);
      let multipleFileData: [] =
        fileData && fileData.map((file: { name: any }) => file.name);
      let singleFileData: [] =
        nameAcceptedFiles &&
        nameAcceptedFiles.map((file: { name: any }) => file.name);
      setFileNames([...singleFileData, ...multipleFileData]);
    } else {
      setFileNames(
        acceptedFiles && acceptedFiles.map((file: { name: any }) => file.name)
      );

      setFileData(acceptedFiles);
    }
  };
  const fileUpload = (e: any) => {
    setLoading(true);
    setFetchingStart(true);

    if (uploadSuccessArray?.length > 0) {
      let filterData = fileData?.filter(
        (el: any) => !uploadSuccessArray.includes(el?.name)
      );
      uploadFiles(filterData);
    } else {
      uploadFiles(fileData);
    }
  };

  useEffect(() => {
    if (uploadSuccessArray?.length === fileNames?.length) {
      setFetchingStart(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadSuccessArray]);

  const uploadFiles = async (uploadedFile: any) => {
    var fileCount = 0;
    async function multipleFile() {
      try {
        let resp;

        const blockBlobClient = containerClient.getBlockBlobClient(
          new Date().valueOf() +
            "." +
            uploadedFile[fileCount].name.split(".")[
              uploadedFile[fileCount].name.split(".").length - 1
            ]
        );

        resp = await blockBlobClient.uploadBrowserData(uploadedFile[fileCount]);

        if (
          resp &&
          resp["_response"] &&
          resp["_response"].status &&
          resp["_response"].status === (201 || 200)
        ) {
          await updateDocumentAPI(
            uploadedFile[fileCount].name,
            blockBlobClient["_name"],
            blockBlobClient["_containerName"],
            uploadedFile[fileCount].type
          );

          setLoading(false);
        } else {
          alert("something wrong");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
      if (fileCount === uploadedFile?.length - 1) {
        return;
      } else {
        fileCount++;
        multipleFile();
      }
    }
    multipleFile();
  };

  const updateDocumentAPI = async (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: UploadFileTypesPayload = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };

    handleUploadFile?.(data);
  };

  const handleFileDelete = (index: number) => {
    let finalFileNameData = fileNames?.filter(
      (item: any, i: number) => i !== index
    );
    let finalFileData = fileData?.filter((item: any, i: number) => i !== index);

    setFileNames(() => finalFileNameData);
    setFileData(() => finalFileData);
  };

  const renderDraggableUpload = () => {
    return (
      <>
        <div
          style={{
            display: fileNames?.length ? "grid" : "",
            gridTemplateColumns: "45% 45%",
            gap: "5%",
            height: "400px",
            justifyContent: "center",
          }}
        >
          <div>
            <Dropzone
              accept={
                acceptedFiles ??
                "image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
              }
              minSize={0}
              // maxFiles={5}
              maxSize={maxSize}
              onDrop={handleDrop}
              multiple={true}
            >
              {({
                getRootProps,
                getInputProps,
                isDragActive,
                isDragReject,
                fileRejections,
              }) => {
                let isFileTooLarge;
                if (maxFileSize) {
                  isFileTooLarge = fileRejections[0]?.file?.size > maxFileSize;
                } else {
                  isFileTooLarge = fileRejections[0]?.file?.size > maxSize;
                }

                return (
                  <div
                    {...getRootProps({
                      className: "dropzone drop-area-white text-center",
                    })}
                    style={{ border: "1px dotted #bfcbe1" }}
                  >
                    <input {...getInputProps()} />
                    <img src={UploadFileIcon} alt="upload" className="mb-4" />

                    {isDragActive && !isDragReject && (
                      <h4 className="text-center">Drop it like it's hot!</h4>
                    )}

                    {isDragReject && (
                      <h4 className="text-center">
                        File type not accepted, sorry!
                      </h4>
                    )}

                    {!isDragActive && (
                      <h4 className="text-center">
                        Drag & drop or{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#dd4433",
                          }}
                        >
                          Choose file{" "}
                        </span>
                        to upload
                      </h4>
                    )}
                    <p className="text-muted text-center">
                      {`Supported formats: ${
                        supportedFiles ??
                        "PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
                      }`}{" "}
                    </p>
                    <p className="text-center text-muted ">
                      {`Max 20 files allowed up to 50 MB`}
                    </p>
                    {isFileTooLarge && (
                      <div className="text-danger mt-2">File is too large.</div>
                    )}
                    {+filesSize > maxSize && (
                      <div className="text-danger mt-2">File is too large.</div>
                    )}
                    {maxFile && (
                      <div className="text-danger mt-2">{maxFile}</div>
                    )}
                  </div>
                );
              }}
            </Dropzone>
            <div
              className="mt-2"
              style={{ width: "100%", textAlign: "center" }}
            >
              {uploadSuccessArray?.length !== fileData?.length &&
              fileNames &&
              fileNames.length ? (
                <Button
                  style={{ width: "100%" }}
                  color="primary"
                  disabled={
                    fetchingStart ||
                    loading ||
                    +filesSize > maxSize ||
                    maxFile?.length > 0
                  }
                  onClick={fileUpload}
                >
                  Upload
                </Button>
              ) : null}
              {uploadSuccessArray?.length > 0 &&
                uploadSuccessArray?.length === fileData?.length && (
                  <span style={{ color: "#82B01F" }}>
                    All files uploaded successfully! You can close this pop-up.
                  </span>
                )}
            </div>
          </div>
          <div style={{ overflowY: "auto", overflowX: "hidden" }}>
            {fileNames && fileNames.length
              ? fileNames.map((item, index) => (
                  <div
                    className="mb-2"
                    style={{
                      border: "1px solid #bfcbe1",
                      borderRadius: "5px",
                      padding: "3% 2%",
                      display: "flex",
                    }}
                  >
                    <div style={{ display: "flex", width: "80%" }}>
                      <div>
                        <img src={FileDescription} alt="file" />
                      </div>
                      <div
                        className="ml-2"
                        key={item}
                        style={{
                          wordWrap: "break-word",
                          borderRadius: "inherit",
                          fontSize: "13px",
                          fontWeight: 500,
                          width: "100%",
                        }}
                      >
                        {item}
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#6e7491",
                            fontWeight: 500,
                          }}
                        >
                          {(fileData?.[index]?.size / 1024).toFixed(2)}KB
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        width: "20%",
                      }}
                    >
                      {!uploadSuccessArray.includes(item) && uploadFetching && (
                        <div>
                          {
                            <img
                              style={{
                                cursor: "pointer",
                                height:
                                  !uploadSuccessArray.includes(item) &&
                                  uploadFetching
                                    ? "40px"
                                    : "",
                                margin:
                                  !uploadSuccessArray.includes(item) &&
                                  uploadFetching
                                    ? "-15px -15px 0 0"
                                    : "",
                              }}
                              src={RollingLoaderGif}
                              alt="delete"
                            />
                          }
                        </div>
                      )}

                      {uploadSuccessArray.includes(item) && (
                        <div>
                          <img
                            style={{ cursor: "pointer" }}
                            src={CheckCircleGreen}
                            alt="delete"
                          />
                        </div>
                      )}

                      {!uploadSuccessArray.includes(item) &&
                        !uploadFetching && (
                          <div>
                            {!uploadSuccessArray.includes(item) &&
                              !uploadFetching &&
                              !fetchingStart && (
                                <img
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleFileDelete(index)}
                                  src={deleteIcon}
                                  alt="delete"
                                />
                              )}
                          </div>
                        )}
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {isDraggableModal ? (
        <Modal
          isOpen={modal}
          backdrop="static"
          centered
          toggle={toggleModal}
          size={fileNames?.length > 0 ? "xl" : "lg"}
        >
          {!fetchingStart ? (
            <ModalHeader toggle={toggleModal}>Upload File</ModalHeader>
          ) : (
            <ModalHeader>Upload File</ModalHeader>
          )}
          <ModalBody>
            {fileData?.length ? (
              <h6 style={{ textAlign: "end", marginRight: "30px" }}>
                {fileData?.length === uploadSuccessArray?.length
                  ? `Total ${fileData?.length} files uploaded`
                  : `Total ${fileData?.length} files uploading`}
              </h6>
            ) : (
              ""
            )}
            {renderDraggableUpload()}
          </ModalBody>
        </Modal>
      ) : (
        renderDraggableUpload()
      )}
    </>
  );
};

export default FileManagerUploadModal;
